import type { LinksItems } from "../../../../../../hooks/useServiceLinks";
import React from "react";
import { ServiceLink } from "../../styles";

export type TServiceLinksList = {
    serviceLinks?: LinksItems;
}

export const ServiceLinksList: React.FC<TServiceLinksList> = ({ serviceLinks = {} }) => {
    const renderServiceLink = (item: LinksItems, index: number) => {
        const renderedElement =
            typeof item.element === "function" ? item.element() : null;

        return (
            <ServiceLink key={index} onClick={item?.action}>
                {renderedElement}
            </ServiceLink>
        )
    }

    return Object.values(serviceLinks).map(
        (item, index) => renderServiceLink(item as LinksItems, index)
    )
}
import type { LinksItems } from "../../../../../../hooks/useServiceLinks";
import React from "react";
import { ServiceLink } from "../../styles";

export type TServiceLinksList = {
    serviceLinks?: LinksItems;
}

export const ServiceLinksList: React.FC<TServiceLinksList> = ({ serviceLinks = {} }) => {
    const renderServiceLink = (item: LinksItems, index: number) => {
        const renderedElement =
            typeof item.element === "function" ? item.element() : null;

        return (
            <ServiceLink key={index} onClick={item?.action}>
                {renderedElement}
            </ServiceLink>
        )
    }

    return Object.values(serviceLinks).map(
        (item, index) => renderServiceLink(item as LinksItems, index)
    )
}
